import { render, staticRenderFns } from "./PurD_Details.vue?vue&type=template&id=f6ee0e0a"
import script from "./PurD_Details.vue?vue&type=script&lang=js"
export * from "./PurD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports